/**
 * 施設/サービスキー → アイコン名マッピング
 *
 * ゲスト側 app/frontend/guest/_shared/src/lib/service-icon-map.ts の
 * 逐語コピー。キー・マッピング変更時はゲスト側と同期すること。
 *
 * 原本コメント:
 * アイコン名は lucide アイコン名またはカスタムアイコン名に対応する。
 * undefined はカテゴリフォールバックを使用することを意味する。
 *
 * 新規施設追加時: このテーブルにエントリを追加するだけでOK。
 * 追加しなくてもカテゴリフォールバックで表示される。
 */
export const SERVICE_ICON_MAP: Record<string, string | undefined> = {
	// ── Facility: 飲食 ──
	cafe: "Coffee",
	bar: "Wine",
	BBQ_facilities: "Grill",
	vending_machines_snack: "Cookie",
	vending_machines_drink: "CupSoda",

	// ── Facility: プール・ウェルネス ──
	pool: "Waves",
	hot_spring: "BathPublicLarge",
	open_air_bath: "BathOutdoor",
	sauna: "Sauna",
	massage: "Hand",

	// ── Facility: 交通 ──
	parking_lot: "CircleParking",
	shuttle: "Bus",
	car_rental: "Car",

	// ── Facility: 共用エリア ──
	public_wifi: "Wifi",
	public_kitchen: "CookingPot",
	lounge: "Sofa",
	library: "BookOpen",
	play_room: "Gamepad2",
	karaoke_room: "Mic",
	public_bathroom: "Bath",
	public_shower: "ShowerHead",
	public_toilet: "DoorOpen",
	public_tv: "Tv",
	netflix: "Tv",
	hulu: "Tv",
	fireplace: "Flame",
	public_iron: "Shirt",
	public_hairdryer: "Wind",
	public_microwave: "Microwave",
	public_electric_kettle: "Kettle",
	public_tableware: "UtensilsCrossed",
	powder_room: "Sparkles",

	// ── Facility: クリーニング ──
	public_laundry: "WashingMachine",
	dry_cleaning: "Shirt",
	ironing_service: "Shirt",

	// ── Amenity: Bathroom ──
	private_bathroom: "Bath",
	unit_bath: "Bath",
	private_open_air_bath: "BathPrivate",
	private_sauna: "Sauna",
	shower: "ShowerHead",
	bathtub: "Bath",
	bath_roab: "Shirt",
	hand_towel: "TowelRack",
	bath_towel: "TowelRack",
	shampoo: "SoapDispenserDroplet",
	conditioner: "SoapDispenserDroplet",
	body_soap: "SoapDispenserDroplet",
	soap: "SoapDispenserDroplet",
	toilet: "DoorOpen",
	large_public_bath: "Bath",
	bath_additive: "Droplets",

	// ── Amenity: Room Amenity ──
	tooth_brush: "Dentistry",
	hair_comb: "SelfCare",
	razor: "Razor",
	cotton_swabs: "SelfCare",
	slipper: "Footprints",
	base_cosmetics: "Droplet",
	toner: "Droplet",
	emulsion: "Droplet",
	shower_cap: "ShowerHead",
	yukata: "Shirt",
	pajama: "Shirt",

	// ── Amenity: Room Facility ──
	wifi: "Wifi",
	fridge: "Refrigerator",
	tv: "Tv",
	audio_equipment: "Speaker",
	projector: "Projector",
	air_conditioner: "AirVent",
	fire_place: "Flame",
	air_cleaner: "Wind",
	humidifier: "CloudRainWind",
	iron: "Shirt",
	dryer: "Hairdryer",
	private_kitchen: "CookingPot",
	cooking_tool: "UtensilsCrossed",
	microwave_oven: "Microwave",
	pot: "Kettle",
	tableware: "UtensilsCrossed",
	washlet: "Droplet",
	private_washing_machine: "WashingMachine",
	balcony: "Fence",
	futon: "BedDouble",
	safe: "Lock",
};

const CATEGORY_FALLBACK = {
	amenity: "ShowerHead",
	facility: "Building2",
} as const;

/** キーとカテゴリからアイコン名を解決 */
export function resolveServiceIconName(key: string, category: "amenity" | "facility"): string {
	return SERVICE_ICON_MAP[key] ?? CATEGORY_FALLBACK[category];
}
